import { render, staticRenderFns } from "./IkeaHome.vue?vue&type=template&id=61b843ee&"
import script from "./IkeaHome.vue?vue&type=script&lang=js&"
export * from "./IkeaHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "IkeaHome.vue"
export default component.exports